import { render, staticRenderFns } from "./NewTemplateView.vue?vue&type=template&id=11efb348"
import script from "./NewTemplateView.vue?vue&type=script&lang=js"
export * from "./NewTemplateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports